import { useState } from "react";
import { Plus, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const slug = (w) => w.replace(/[^a-z0-9]+/g, "-");

// Chip list editor for "list" settings (array of strings). Items are trimmed, lowercased and de-duplicated.
export default function ListEditor({ id, settingKey, items, max, onChange }) {
  const [text, setText] = useState("");
  const [note, setNote] = useState(null);
  const full = max != null && items.length >= max;

  function add() {
    const words = text.split(",").map((w) => w.trim().toLowerCase().replace(/\s+/g, " ")).filter(Boolean);
    if (!words.length) return;
    const fresh = words.filter((w, i) => !items.includes(w) && words.indexOf(w) === i);
    const room = max != null ? Math.max(0, max - items.length) : fresh.length;
    if (fresh.length) onChange([...items, ...fresh.slice(0, room)]);
    setNote(fresh.length < words.length ? "Already in the list." : fresh.length > room ? `Limit is ${max}.` : null);
    setText("");
  }

  return (
    <div data-testid={`setting-list-${settingKey}`}>
      <ul className="flex flex-wrap gap-2" aria-label="Current items">
        {items.map((w) => (
          <li key={w} className="inline-flex items-center gap-1 rounded-full bg-[var(--cw-surface-tertiary)] py-1 pl-3 pr-1 text-sm" data-testid={`setting-list-chip-${settingKey}-${slug(w)}`}>
            {w}
            <button type="button" onClick={() => onChange(items.filter((x) => x !== w))} aria-label={`Remove ${w}`}
              className="cw-muted flex h-6 w-6 items-center justify-center rounded-full transition-colors hover:bg-white hover:text-foreground" data-testid={`setting-list-remove-${settingKey}-${slug(w)}`}>
              <X size={12} />
            </button>
          </li>
        ))}
        {!items.length && <li className="cw-muted text-sm">No items.</li>}
      </ul>
      <div className="mt-3 flex gap-2">
        <Input id={id} value={text} onChange={(e) => { setText(e.target.value); setNote(null); }} disabled={full}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          placeholder={full ? `Limit of ${max} reached` : "Add a word or phrase, then press Enter"} className="h-10 rounded-xl bg-white" data-testid={`setting-list-input-${settingKey}`} />
        <Button type="button" variant="outline" onClick={add} disabled={full || !text.trim()} data-testid={`setting-list-add-${settingKey}`}><Plus />Add</Button>
      </div>
      <p className="cw-muted mt-1.5 text-xs" data-testid={`setting-list-count-${settingKey}`}>
        {items.length}{max != null ? `/${max}` : ""} items · saved lowercase{note && <span className="cw-warning ml-2">{note}</span>}
      </p>
    </div>
  );
}
